import react, { useLayoutEffect, useState } from "react";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { Trans, useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router';
import '../coursewares/coursewares.scss'
import * as images from './coursewares-images';
import StopMotionSvg from "../../components/StopMotionSvg";
import DashedDrawedSvg from "../../components/DashedDrawedSvg";
import CommonButton from "../../components/button/button";
import FillDrawedSvg from "../../components/common/fill-drawed-svg";
import ModalOpenButton from "../../components/common/modal";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

function Coursewares() {

    const { reloadState } = useOutletContext();
    const { t } = useTranslation();
    const [isRtl, setIsRtl] = useState(1);
    const [isBooksHover, setIsBooksHover] = useState(false);
    const [intervalSection2, setIntervalSection2] = useState(null);
    const [intervalSection6Arrow, setIntervalSection6Arrow] = useState(600);
    const deviceType = useDeviceDetection();

    useLayoutEffect(() => {
        window.scrollTo({ top: 0 });
        reloadState[1](false);
        console.log("Igot there", reloadState[0]);

    }, []);

    useGSAP((context) => {

        //#region section 1

        gsap.to('#coursewares-header', {
            scrollTrigger: {
                trigger: '#section1',
                start: 'top top',
                end: 'bottom top',
                scrub: true,
            },
            scale: 1.81
        });
        //#endregion

        //#region section 2
        const tl = gsap.timeline();
        ScrollTrigger.create({
            animation: tl,
            trigger: '.section-2',
            start: "top 70%",
            end: '10% 20%',
            scrub: true
        });
        tl.fromTo(".section-2 .row .item",
            {
                autoAlpha: 0,
                y: 100,
            },
            {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                stagger: .35
            }
        )
            .add(() => setIntervalSection2(i => !i ? 400 : null), '-=0.2')

        //#endregion

        if (deviceType?.isMobile) {
            const smallWowTl = gsap.timeline({ repeat: -1, paused: true })
                .set('.teddy-bear-background svg', { y: -25, x: -23, rotate: -35 }, 0)
                .set('.teddy-bear-background svg', { y: 0, x: 0, rotate: 0 }, 0.6)
                .set('.teddy-bear-background svg', { y: -25, x: -23, rotate: -35 }, 1.2)

            gsap.from('#big-wow', {
                scale: 0.61, ease: "power2.out",
                scrollTrigger: {
                    trigger: '#big-wow', start: 'top bottom', scrub: 1, end: 'top center',
                    onLeave: () => smallWowTl.play(), onEnterBack: () => smallWowTl.pause()
                }
            })

        }
        //#region section 10

        gsap.timeline({ repeat: -1 })
            .to('.button-container button.horse', { scale: 1.3 }, 0)
            .to('.button-container button.horse', { scale: 1 }, 1.2)

        //#region - section 12 white svg entering
        gsap.from('div.s-10-d svg', {
            scrollTrigger: {
                trigger: 'div.s-10-d svg',
                start: '20% bottom',
                end: 'center center',
                scrub: 0.5,
            },
            xPercent: 100,
            opacity: 0,
        });
        //#endregion

        //#endregion

        //#region section 13 -  prouductions row go up on e after onother

        const boxesTl = gsap.timeline();

        ScrollTrigger.create({
            animation: boxesTl,
            trigger: '.section-13',
            endTrigger: '.section-13 .sub-title',
            start: "top 70%",
            end: 'top 20%',
            scrub: true
        });

        boxesTl.fromTo(".section-13 .productions .box",
            {
                autoAlpha: 0,
                y: 30,
            },
            {
                autoAlpha: 1,
                y: 0,
                stagger: .5,
                ease: 'power1.out'
            }
        )

        //#endregion

        //#region section 14 - yalla button flash

        const yallaTl = gsap.timeline();

        ScrollTrigger.create({
            animation: yallaTl,
            trigger: '.section-14 .common-button',
            start: "center 39%"
        });

        yallaTl
            .set('.section-14 .common-button', { transition: 'none !important' })
            .to('.section-14 .common-button', {
                background: 'var(--orange-hover)'
            }, 0.1)
            .to('.section-14 .common-button', {
                background: 'var(--orange)'
            }, 0.321)
            .to('.section-14 .common-button', {
                background: 'var(--orange-hover)'
            }, 0.521)
            .to('.section-14 .common-button', {
                background: 'var(--orange)'
            }, 0.721
            )
            .set('.section-14 .common-button', { transition: 'background 0.4s' })

        //#endregion    

        //#region dancing items

        //section 6 arrow
        gsap.timeline({ repeat: -1 })
            .set('.books .hand', { y: 30, x: -13 }, 0)
            .set('.books .hand', { y: 0, x: 0 }, 0.8)
            .set('.books .hand', { y: 30, x: -13 }, 1.6)




        // section 10 C img dancing
        gsap.timeline({ repeat: -1 })
            .set('.stars path', { fill: 'var(--orange)' }, 0)
            .set('.stars path', { fill: 'var(--green)' }, 0.6)
            .set('.stars path', { fill: 'var(--purple)' }, 1.2)
            .set('.stars', { fill: 'var(--orang)' }, 1.8)


        // // section 10 C img dancing
        gsap.to(".disco", {
            rotation: 90, // Rotate by 360 degrees
            ease: "linear", // Smooth constant speed
            scrollTrigger: {
                trigger: '.disco',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1

            },

        });

        // section 14
        gsap.timeline({ repeat: -1 })
            .set('.section-14-images .hand', { y: 70, x: -13 }, 0)
            .set('.section-14-images .hand', { y: 100, x: 0 }, 0.8)
            .set('.section-14-images .hand', { y: 70, x: -13 }, 1.6)

        //#endregion


        setTimeout(() => {
            // Ensure ScrollTrigger recalculates positions
            ScrollTrigger.refresh();
        }, 100);

        return () => {
            context.kill();
        }
    }, { dependencies: [deviceType] })

    const comeToPlayButtonNote = <span className={'notes'}>{t('coursewares.come-to-play')}</span>;
    const comeToPlayButtonContainer = <div className='chess-run-button-container flex'>
        <ModalOpenButton content={{ commonVidoe: 'lomdot_play', vidoePoster: images.gamesImg }} modalType={'fade'}
            triggerButton={onClick =>
                <button onClick={onClick} className="horse" type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true" >
                    {images.r.horseBtn.circle}
                    <img src={images.r.horseBtn.horse} alt="" />
                </button>
            } />
        {images.r.horseBtn.arrow}

        {!deviceType?.isMobile && comeToPlayButtonNote}
    </div>;

    return <>
        <div className="coursewares-component">
            <section id="section-1" className="section-1">
                <h1 id="coursewares-header" className='headline'>
                    {t('coursewares.coursewares')}
                </h1>
            </section>

            {/* section 2 */}
            <section className='section-2' id="section2">
                <div className='sub-title'>
                    <Trans i18nKey="coursewares.What learning platforms will you find with us">
                        What learning <span className='marked-text'>coursewares</span> will you find with us
                    </Trans>
                </div>

                <div className="coursewares-types" id='coursewares-types'>
                    <div className="row">
                        {images.coursewaresTyp.map((item, index) => (
                            <div className="item" key={`item${index}`}>
                                <div className='dancing-lines-container' width={item.width} height={item.height}
                                    style={{
                                        marginInline: item.marginInline, marginBlock: item.marginBlock,
                                        ...(item.justifyContent && { justifyContent: item.justifyContent })
                                    }}>
                                    <StopMotionSvg
                                        shapes={item.shapes}
                                        width={item.widthSvg}
                                        height={item.heightSvg}
                                        interval={intervalSection2}
                                    />
                                </div>
                                <div className={`related-image ${item.name}`}>
                                    <img src={item.img} alt={t(`coursewares.section-2.${item.name}`)} />
                                </div>
                                <p className={`${item.name}-p text-run`} >{t(`coursewares.section-2.${item.name}`)}</p>
                                <div className="banner">
                                    {deviceType?.isMobile ?
                                        <>{item.svgShadowMobile}
                                            {item.svgMobile}</>
                                        : <>{item.svgShadow}
                                            {item.svg}</>
                                    }
                                    <span>{t(`coursewares.section-2.${item.description}`)}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* section 3 */}
            {deviceType?.isMobile ? <div className="mobile-dash-line" id="mobile-dash-line-1">
                <DashedDrawedSvg svgWidth="201" svgHeight="196"
                    d="M63.1351 8.41199C115.955 -17.9374 33.0592 123.314 113.817 79.502C149.15 60.334 142.91 180.729 132.972 193.808"
                    strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                    trigger='#mobile-dash-line-1' startTrigger="top 95%" endTrigger="bottom 10%" />
            </div> : <section className="section-3">
                <div className='transition-1' id="transition-1">
                    <DashedDrawedSvg d='M303.532 23.1964C242.3361 -71.4278 241.308 241.24 151.168 90.7725C111.731 24.9415 5 228.851 8.622 260' strokeDasharray='940'
                        svgWidth='305' svgHeight='261' diffrentTriggerEnd='.section-4'
                        trigger='#coursewares-types' startTrigger="top 10%" endTrigger="bottom top" />
                </div>
            </section>
            }
            {/* section 4 */}
            <section className="section-4">
                <div>
                    <div className="text-label">
                        <div className="paragraph">
                            <span className="titel">{t('coursewares.Did you know')}</span>
                            <span className="text-run">{t('coursewares.The most searched-for button in a learning platform is')}</span>
                        </div>
                        <div className="paragraph">
                            <span className="marked-text">!!{t('coursewares.Next')}</span>
                            <span className="text-run">{t('coursewares.Meaning come on take me to the end of the learning platform')}</span>
                        </div>
                    </div>
                </div>
                <div className="sucking">
                    <div className="sucking-img">
                        <img src={images.sucking} alt="" />
                    </div>
                    <div>
                        <StopMotionSvg
                            shapes={images.lines}
                            width={362}
                            height={186}
                            interval={intervalSection2}
                        />
                    </div>
                </div>

            </section >

            {/* section 5 */}
            {deviceType?.isMobile ?
                <div className="mobile-dash-line section-5" id="mobile-dash-line-2">
                    <DashedDrawedSvg svgWidth="201" svgHeight="194"
                        d="M53.6371 12.9129C0.36758 38.3403 162.721 59.8975 78.4966 96.6058C41.6474 112.666 140.397 181.82 156.822 182.033" strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-2' startTrigger="top 95%" endTrigger="bottom 10%" />
                </div> :
                <section className="section-5">
                    <div className='transition-2' id="transition-2">
                        <DashedDrawedSvg d='M50.2673 4.49964C-52.6831 9.82834 182.539 144.586 25.0643 148.189C-43.8325 149.765 85.0907 274.263 104.62 283.731' strokeDasharray='540'
                            svgWidth='107' svgHeight='288'
                            trigger='.section-5' startTrigger="top 70%" endTrigger="bottom 20%" />
                    </div>
                </section>
            }

            {/* section 6 */}
            <section className="section-6">
                <div className='sub-title'>
                    <Trans i18nKey="coursewares.We create learning platforms that people want to stay on">
                        We create <span className='marked-text'>coursewares</span> that people want to stay on
                    </Trans>
                </div>

                {/* section 6 - row 1 */}
                <div className="s-6-row-1">
                    <div className="background-svg">
                        {images.WowConatinerImages.svgs.map(s => s)}
                    </div>
                    {deviceType?.isMobile ?
                        <img alt="Wow" src={images.WowConatinerImages.teddyBearManMobileImmg}></img>
                        :
                        <> <div className='transition-3' id="transition-2">
                            <DashedDrawedSvg d='M2.1041 29.5373C28.3795 15.3811 270.696 -27.9837 216.855 50.2216C93.7932 228.973 487.728 91.5249 410.578 210.787' strokeDasharray='640'
                                svgWidth='426' svgHeight='214'
                                trigger='.transition-3' startTrigger="top 70%" endTrigger="bottom 20%" />
                        </div>

                            <div className="teddy-bear-background background-image-included">
                                {images.WowConatinerImages.wowSvg}
                                <img alt="Wow" src={images.WowConatinerImages.bigWow} id='big-wow'></img>
                            </div>
                        </>
                    }
                </div>

                {/* section 6 - row 2 */}
                <div className="s-6-row-2 flex">
                    <div className="flex-coumn">
                        <p className={'text-run'}>{t('coursewares.So either download from our shelf the learning platform that fits your organization')}</p>
                        <div className={`books background-image-included ${isBooksHover && 'hover'}`}>
                            {images.clickHereArrow}
                            {deviceType?.isMobile ? <ModalOpenButton content={{ commonVidoe: 'lomdot_madaf', vidoePoster: images.shelf }} modalType={'fade'}
                                triggerButton={onClick =>
                                    <button onClick={onClick} className="books-button" type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true" aria-lable={t('coursewares.click-here')}                                    >
                                    </button>
                                } />
                                : <> <img src={images.booksHand} alt="" className="hand no-flip" />
                                    <ModalOpenButton content={{ commonVidoe: 'lomdot_madaf', vidoePoster: images.shelf }} modalType={'fade'}
                                        triggerButton={onClick =>
                                            <button onClick={onClick} type='button' aria-label='לצפיה בטרנדים החמים' tabIndex="true" className="click-here" aria-lable={t('coursewares.click-here')}
                                                onMouseEnter={() => setIsBooksHover(true && !deviceType?.isMobile)} onMouseLeave={() => setIsBooksHover(false)}>
                                                {t('coursewares.click-here')}
                                                <span>{images.clickHereSvg}</span>
                                            </button>
                                        } /></>}
                        </div>
                    </div>
                </div>

                {/* section 6 - row 3 */}
                <div className={'flex-column  s-6-row-3'}>
                    <p className={'text-run'}>{t('coursewares.Or we will create a surprising learning platform together')}</p>

                    <img src={images.s6Row3Images.koooko} alt='' />

                    <StopMotionSvg
                        shapes={images.s6Row3Images.lines}
                        width={310}
                        height={254}
                        interval={500}
                    />
                </div>

                {deviceType?.isMobile && <div className="mobile-dash-line" id="mobile-dash-line-4">
                    <DashedDrawedSvg svgWidth="195" svgHeight="202"
                        d="M13.5282 54.52C38.9556 1.25039 60.5127 163.604 97.221 79.3794C113.281 42.5302 182.436 141.28 182.649 157.704"
                        strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                        trigger='#mobile-dash-line-4' startTrigger="top 95%" endTrigger="bottom 10%" />
                </div>}

                {/* section 6 - row 4 */}
                <div className={'flex-column  s-6-row-4'}>
                    <p className={'text-run'}>{t('coursewares.A platform that provides an opportunity to play even during work')}</p>
                    <div className="chess-on-road-container">
                        {deviceType?.isMobile && <img src={images.r.chessBoard} alt=""></img>}
                        <FillDrawedSvg />
                        {!deviceType?.isMobile && (<>
                            <img src={images.r.chessBoard} alt=""></img>
                            {comeToPlayButtonContainer}
                        </>)}
                    </div>
                    {deviceType?.isMobile &&
                        <>
                            {comeToPlayButtonNote}
                            {comeToPlayButtonContainer}
                        </>}

                </div>
            </section>

            <section className="section-7">
                <p className={'text-run'}>{t('coursewares.A platform that gives a stage to your employees too')}</p>

                <div className="stage flex">
                    <div className="singer-with-stars flex-column">
                        {images.section7Images.stars}
                        <img src={images.section7Images.singer} alt="" />

                        <StopMotionSvg
                            shapes={images.section7Images.lines}
                            width={220}
                            height={128}
                            interval={400}
                        />

                    </div>
                    <img src={images.section7Images.girls} alt="" className="girls" />

                    {images.section7Images.stage}
                    <img src={images.section7Images.disco} className="disco" alt="" />
                </div>
            </section>


            {/* section 13 */}
            < section className='section-13' id='section13' >
                <div className='sub-title'>
                    <Trans i18nKey="coursewares.What does the learning platform development process include">
                        What does the  <span className='marked-text'>coursewares</span> development process include?
                    </Trans>
                </div>

                <div className='productions'>
                    {images.whoIsInTheSupportTeamBoxes.map((item, index) => (
                        <div className="box" key={`item${index}`}>
                            {item.svgElement}
                            <span>{t(`coursewares.development process include.${item.description}`)}</span>
                        </div>
                    ))}
                </div>
            </section >

            {deviceType?.isMobile && <div className="mobile-dash-line" id="mobile-dash-line-3">
                <DashedDrawedSvg svgWidth="201" svgHeight="196"
                    d="M63.1351 8.41199C115.955 -17.9374 33.0592 123.314 113.817 79.502C149.15 60.334 142.91 180.729 132.972 193.808"
                    strokeDasharray={340} maskStrokDashArrayc='11' strokeWidth={11}
                    trigger='#mobile-dash-line-3' startTrigger="top 95%" endTrigger="bottom 10%" />
            </div>}

            {/* section 14 */}
            < section className='section-14' id='section14' >
                <div className='yalla'>
                    <div className='sub-title'>
                        <Trans i18nKey="coursewares.Shall we get started on a new and surprising learning platform">
                            Shall we get started on a new and surprising learning <span className='marked-text'>courseware</span> ?
                        </Trans>
                    </div>
                    <div className='flex'>
                        <CommonButton
                            text={t("coursewares.Next")}
                            routePath='/contact-us'
                        />
                        {images.section14Decorations.lines}
                    </div>
                </div>
                <div className='section-14-images'>
                    <img src={images.section14Decorations.image} alt='' className="hand" />
                    <img src={images.section14Decorations.tringles} alt='' />

                </div>
            </section >
        </div >
    </>
}

export default Coursewares;